export const ruNumberFormat = (
  num: number,
  options?: Intl.NumberFormatOptions
) => new Intl.NumberFormat('ru-Ru', options).format(num);
